module.exports = __webpack_public_path__ + "img/f139388.png";